import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { OrderInfoResponse } from '@/cowboy/order_info/object/OrderInfoResponse'

export class OrderInfoApi extends HttpInjector {
  /**
   * fetchOriginalOrderInformation retrieves the P-hash which is used to evaluate feature flags in subsequent
   * requests.  This needs to happen before other API requests.  This is primarily for the "maintenance mode" which
   * is controlled by a long lived feature flag.  The API endpoints themselves are "smart" enough to retrieve the
   * P-hash if it isn't provided.
   * @return {Promise<OrderInfoResponse>}
   */
  static async fetchOriginalOrderInformation () {
    const response = await this.$http.get(`/sv/${this.codeVersion.requestCode}/order-info?urlVersion=${this.codeVersion.urlVersion}`)
    return this.cast(response.data, OrderInfoResponse)
  }
}
